'use client';

import React from 'react';

import { cmsContentList } from '@pt-group-fe/styled-system/recipes';

import type { Cms_ContentListItem } from '@lib/services/cms';
import { CmsEditorText } from '@lib/ui/cmsEditorText';
import { Icon } from '@lib/ui/icon';

interface Props {
  data: Cms_ContentListItem;
}

const ContentListItem: React.FC<Props> = ({ data }) => {
  const { container, icon } = cmsContentList();

  return (
    <div className={container}>
      <Icon i={'check-circle'} className={icon} />

      <CmsEditorText variant="blockLg" data={data.text} />
    </div>
  );
};

export default ContentListItem;
